module.exports = __webpack_public_path__ + "assets/img/ph_overview_donut.d9f9f54d.svg";